import { AttachmentDataFragment } from "@bonliva-crm/graphql";
import * as yup from "yup";

export type EmailEditorFormValues = {
  recipients: { email: string; name: string }[];
  subject: string;
  body: string;
  attachments: AttachmentDataFragment[];
};

export const emailEditorFormSchema = yup.object({
  recipients: yup.array().min(1).required(),
  subject: yup.string().required(),
  body: yup.string().required().nullable(false),
  attachments: yup.array(
    yup
      .object({
        NodeID: yup.string().required(),
        Name: yup.string().nullable(true),
        Size: yup.number().required()
      })
      .required()
  )
});
